<template>
  <main>
    <b-container v-if="project && model">
      <div class="page-breadcrumb">
        <router-link
            :to="{
              name: 'ModelView',
              params: { modelId: model._id, projectId: project._id }
            }"
            class="border-0"
          >
            <i class="fa fa-angle-left" /> Back to project: {{ project.name }}
        </router-link>
      </div>

      <div class="section-header">
        <h1 class="heading">Edit {{ model.name }}</h1>

        <div class="actions"></div>
      </div>

      <div class="layoutcard">
        <b-row>
          <b-col cols="8" lg="7">
            <ModelForm
              :form="form"
              :model-create-visible="false"
              @callback="submit"
            ></ModelForm>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </main>
</template>

<script>
import { mapActions } from "vuex";
import InitAdmin from "../Shared/InitAdmin";
import ModelForm from "./ModelForm";

export default {
  name: "ModelEdit",
  components: {
    ModelForm
  },
  extends: InitAdmin,
  data() {
    return {
      project: null,
      model: null,
      form: {
        name: null,
        description: null
      }
    };
  },
  mounted() {
    this.loadProject({ id: this.$route.params.projectId }).then(res => {
      this.project = res;
    });
    this.loadModel({ id: this.$route.params.modelId }).then(res => {
      this.model = res;
      this.form = { ...res };
    });
  },
  methods: {
    ...mapActions(["loadProject", "loadModel", "updateModel"]),
    submit() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$toasted.show(this.$validator.errors.items[0].msg, {
            type: "error"
          });
          return;
        }
        this.updateModel({
          modelId: this.$route.params.modelId,
          model: {
            name: this.form.name,
            description:
              this.form.description === null ? "NA" : this.form.description
          }
        }).then(() => {
          this.$toasted.show("Model Updated");
          setTimeout(() => {
            this.$router.push({
              name: "ModelView",
              params: {
                modelId: this.model._id,
                projectId: this.project._id
              }
            });
          }, 1000);
        });
      });
    }
  }
};
</script>
